// extracted by mini-css-extract-plugin
export default {"video_container":"BannerVideo_video_container__jQ50S","bgBlack":"BannerVideo_bgBlack__pJkBN","playbutton":"BannerVideo_playbutton__JCDut"};